import React from 'react';

const LoginOverlay = ({
  heading = '🚀 Join FinTorro',
  description = 'Log in or create a free account to continue your journey.',
  redirectUrl = '/agent-access',
  onClose = () => {}
}) => {
  return (
    <div style={{
      position: 'fixed',
      top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.75)',
      zIndex: 9999,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: 'Nunito Sans, sans-serif',
    }}>
      <div style={{
        backgroundColor: '#181B1F',
        padding: '2rem 2.5rem',
        borderRadius: '20px',
        maxWidth: '400px',
        textAlign: 'center',
        boxShadow: '0 0 20px rgba(0,0,0,0.3)',
        color: '#ffffff'
      }}>
        <div style={{
          fontSize: '26px',
          fontWeight: 700,
          marginBottom: '0.75rem',
          color: '#FF7C24'
        }}>{heading}</div>
        
        <p style={{
          fontSize: '16px',
          marginBottom: '2rem',
          color: '#ffffff'
        }}>{description}</p>

        <button
          onClick={() => window.location.href = redirectUrl}
          style={{
            width: '100%',
            padding: '0.75rem',
            marginBottom: '1rem',
            fontSize: '16px',
            fontWeight: '600',
            backgroundColor: '#FF7C24',
            color: '#fff',
            border: 'none',
            borderRadius: '12px',
            cursor: 'pointer'
          }}
        >
          Log in / Sign up
        </button>

        {/* <button
          onClick={onClose}
          style={{
            background: 'none',
            border: 'none',
            color: '#ccc',
            textDecoration: 'underline',
            cursor: 'pointer',
            fontSize: '14px'
          }}
        >
          Maybe later
        </button> */}
      </div>
    </div>
  );
};

export default LoginOverlay;
